import { ClientEquipamentApi } from './clientEquipamentDetailsApi';

function formatEquipmentData(data) {
  const equipment = data?.equipamento || data || {};

  return {
    equipamento: {
      id: equipment.id,
      nome: equipment.name || equipment.nome,
      marca: equipment.brand || equipment.marca,
      modelo: equipment.model || equipment.modelo,
      ca: equipment.ca,
      serie: equipment.serial_number || equipment.serie,
      ultima_revisao: equipment.last_review || equipment.ultima_revisao,
      proxima_revisao: equipment.next_review || equipment.proxima_revisao,
    },
    fotos: data?.photos || data?.fotos || [],
    laudos: data?.reports || data?.laudos || []
  };
}

function formatPhotoData(photo) {
  return {
    nome_arquivo: photo.file_url || photo.nome_arquivo,
    nome: photo.name || photo.nome
  };
}

function formatReportData(report) {
  return {
    created_at: report.created_at,
    nome_arquivo: report.file_name || report.nome_arquivo,
    nome: report.name || report.nome,
    descricao: report.description || report.descricao
  };
}

function getEquipmentDetails(id) {
  return ClientEquipamentApi.getEquipmentDetails(id)
    .then(response => formatEquipmentData(response.data));
}

function getEquipmentPhotos(id) {
  return ClientEquipamentApi.getEquipmentPhotos(id)
    .then(response => {
      const photos = Array.isArray(response.data) ? response.data : (response.data?.fotos || response.data?.photos || []);
      return photos.map(photo => formatPhotoData(photo));
    });
}

function getEquipmentReports(id) {
  return ClientEquipamentApi.getEquipmentReports(id)
    .then(response => {
      const reports = Array.isArray(response.data) ? response.data : (response.data?.laudos || response.data?.reports || []);
      return reports.map(report => formatReportData(report));
    });
}

function downloadReport(fileName) {
  return ClientEquipamentApi.downloadReport(fileName)
    .then(response => {
      // Cria um blob URL para download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    });
}

export const ClientEquipamentService = {
  getEquipmentDetails,
  getEquipmentPhotos,
  getEquipmentReports,
  downloadReport,
  formatEquipmentData,
  formatPhotoData,
  formatReportData
}
